import {string, object} from 'yup'

const schema = object().shape({
  name: string().required('Il nome è obbligatorio'),
  address: string().required("L'indirizzo è obbligatorio"),
})
export default schema
